import apiService from './apiService';

/**
 * Service pour les attributs de produits
 */
class ProductAttributeService {
  /**
   * Récupère la liste des attributs avec filtres
   * @param {Object} params - Paramètres de recherche
   */
  async getAttributes(params = {}) {
    const response = await apiService.get('/product-attributes', params);
    return response.data;
  }

  /**
   * Récupère un attribut spécifique
   * @param {string} id - ID de l'attribut
   */
  async getAttribute(id) {
    const response = await apiService.get(`/product-attributes/${id}`);
    return response.data;
  }

  /**
   * Crée un nouvel attribut
   * @param {Object} attributeData - Données de l'attribut (name)
   */
  async createAttribute(attributeData) {
    const response = await apiService.post('/product-attributes', attributeData);
    return response.data;
  }

  /**
   * Met à jour un attribut
   * @param {string} id - ID de l'attribut
   * @param {Object} attributeData - Nouvelles données
   */
  async updateAttribute(id, attributeData) {
    const response = await apiService.put(`/product-attributes/${id}`, attributeData);
    return response.data;
  }

  /**
   * Supprime un attribut
   * @param {string} id - ID de l'attribut
   */
  async deleteAttribute(id) {
    return apiService.delete(`/product-attributes/${id}`);
  }

  // === Valeurs d'attributs ===

  /**
   * Récupère la liste des valeurs d'attributs
   * @param {Object} params - Paramètres de recherche
   */
  async getAttributeValues(params = {}) {
    const response = await apiService.get('/product-attribute-values', params);
    return response.data;
  }

  /**
   * Récupère une valeur d'attribut spécifique
   * @param {string} id - ID de la valeur
   */
  async getAttributeValue(id) {
    const response = await apiService.get(`/product-attribute-values/${id}`);
    return response.data;
  }

  /**
   * Crée une nouvelle valeur d'attribut
   * @param {Object} valueData - Données de la valeur (value, product_attribute_id)
   */
  async createAttributeValue(valueData) {
    const response = await apiService.post('/product-attribute-values', valueData);
    return response.data;
  }

  /**
   * Met à jour une valeur d'attribut
   * @param {string} id - ID de la valeur
   * @param {Object} valueData - Nouvelles données
   */
  async updateAttributeValue(id, valueData) {
    const response = await apiService.put(`/product-attribute-values/${id}`, valueData);
    return response.data;
  }

  /**
   * Supprime une valeur d'attribut
   * @param {string} id - ID de la valeur
   */
  async deleteAttributeValue(id) {
    return apiService.delete(`/product-attribute-values/${id}`);
  }
}

const productAttributeServiceInstance = new ProductAttributeService();
export default productAttributeServiceInstance;
